import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { RadarChart } from "@/components/RadarChart";
import { APP_URL } from "@/components/SiteNav";
import { PromoPill } from "@/components/aziende/Promo";

export const AziendeHero = () => (
  <section className="relative px-6 pt-36 pb-20 lg:pt-48 lg:pb-36" data-testid="aziende-hero-section">
    <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center">
      <Reveal>
        <p className="text-xs tracking-[0.3em] uppercase text-titanium mb-8">Per le Aziende</p>
        <h1 className="font-extrabold tracking-[-0.045em] leading-[0.98] text-5xl sm:text-6xl lg:text-7xl" data-testid="aziende-hero-title">
          Intelligenza Caratteriale.
        </h1>
        <p className="mt-6 text-xl sm:text-2xl font-light text-white/90 tracking-[-0.015em]" data-testid="aziende-hero-subline">
          Valutiamo chi sono, non solo cosa sanno fare.
        </p>
        <p className="mt-8 text-base sm:text-lg text-titanium leading-relaxed max-w-xl" data-testid="aziende-hero-body">
          Prodigy non è più solo recruiting: è la piattaforma che ti fa trovare le persone giuste, con i Pool Junior e
          Senior, il test attitudinale e l'AI, e capire come stanno quelle che hai già, con Prodigy Insights.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row gap-3 sm:gap-4">
          <a href={APP_URL} target="_blank" rel="noopener noreferrer" className="cta cta-primary cta-solid group inline-flex min-h-[52px] items-center justify-center gap-2.5 rounded-full border px-8 py-4 text-sm sm:text-base font-semibold text-white" data-testid="aziende-hero-access">
            Richiedi l'accesso <ArrowUpRight className="h-4 w-4 text-cyan" />
          </a>
          <Link to="/aziende/piani" className="cta cta-ghost glass group inline-flex min-h-[52px] items-center justify-center gap-2.5 rounded-full border px-8 py-4 text-sm sm:text-base font-semibold text-white/85" data-testid="aziende-hero-plans">
            Scopri i pacchetti <ArrowRight className="h-4 w-4 text-cyan transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </div>
        <PromoPill />
      </Reveal>
      <Reveal delay={150} className="w-full max-w-[580px] lg:ml-auto">
        <div className="glass rounded-[28px] p-4 sm:p-6" data-testid="aziende-radar-card">
          <RadarChart separator="•" />
        </div>
      </Reveal>
    </div>
  </section>
);
